import React from 'react';
import Config from '../../config/Config';
import { setShowError } from '../../redux/utilities/utils.actions';
import { getSupportPhone } from '../../utils/commonFunctions';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';

const ErrorModal = ({
	errorMsg,
	showError,
	showErrorOKbtn,
	setShowError,
	hideTryagain = true,
	tryagain = '',
	supportPhone,
}) => {
	let recordRegex = new RegExp('Please try recording again');
	let CouponRegex = new RegExp('Please enter the coupon code.');

	const goToMyCourse = () => {
		window.history.pushState(
			null,
			null,
			`${window.location.origin}/mycourse`,
		);
		window.history.go();
	}

	if (
		errorMsg ===
		`<span>This product is not available for you. Please call/message us at <a href="https://web.whatsapp.com/send?phone=+91${supportPhone || 9789883344
		}&text=Hello%2C%20I%27m%20Interested%20in%20buying%20this%20course" target="_blank" rel="noopener noreferrer">+91-${supportPhone || 9789883344
		}</a> for more details.</span>` ||
		errorMsg === getSupportPhone(supportPhone)
	) {
		tryagain = (
			<p>
				Go back to
				<a target="_self" href="buycourse">
					{' '}
					Product{' '}
				</a>
				page
			</p>
		);
	} else if (errorMsg === 'Payment already processed') {
		tryagain = (
			<p>
				Go to
				<a target="_self" href="mycourse">
					My Course
				</a>
				page
			</p>
		);
	} else if (
		errorMsg ===
		'Please complete your background profile information to proceed further.'
	) {
		tryagain = (
			<p>
				Go to
				<a target="_self" href="/profile">
					Profile
				</a>
				page
			</p>
		);
	} else if (recordRegex.test(errorMsg) || CouponRegex.test(errorMsg)) {
		tryagain = '';
	} else if (
		errorMsg ===
		'We did not find any valid courses associated with your login. Please check your login information before trying again.'
	) {
		tryagain = '';
	} else if (hideTryagain) {
		tryagain = '';
	} else {
		tryagain = <p>Please try again.</p>;
	}
	const handleClose = () => setShowError(false);

	return (
		<Modal
			show={showError}
			size="xl"
			dialogClassName="modal-90w"
			onHide={handleClose}
			backdrop={showErrorOKbtn ? 'static' : true}
			keyboard={false}
			id="error-popup"
		>
			{showErrorOKbtn ?
				<Modal.Header></Modal.Header>
				: <Modal.Header closeButton></Modal.Header>
			}
			<Modal.Body size="lg" className="text-center">
				<div className="error-heading">
					<img src={Config.ASSETSPATH + 'img/alert.png'} alt="alert" />
				</div>
				<p dangerouslySetInnerHTML={{ __html: errorMsg }} />
				{!!tryagain || !!errorMsg ? tryagain : 'Please try again.'}
				{showErrorOKbtn &&
					errorMsg !== 'This test is not allowed to be taken on a mobile phone. Please use a desktop or laptop.' && <button className='btn btn-md btn-info' onClick={goToMyCourse}>Please retake the test.</button>}
			</Modal.Body>
		</Modal>
	);
};
const mapStateToProps = (state) => {
	const { errorMsg, showError, showErrorOKbtn } = state.rootReducer.utils;
	const { supportPhone = 9789883344 } = state.rootReducer.loginDetails;
	return {
		errorMsg,
		showError,
		showErrorOKbtn,
		supportPhone,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		setShowError: (val) => dispatch(setShowError(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);